module.exports = __webpack_public_path__ + "img/9788971995631.264eff8b.jpg";